import { configureStore } from '@reduxjs/toolkit';
import { attachStore } from '@shared/api/client';
import signalRMiddleware from 'redux_store/middleware/alertsMiddleware';
import navigationMiddleware from 'redux_store/middleware/navigationMiddleware';
import debugMiddleware from 'redux_store/middleware/debugMiddleware';
import {
  appSettingsReducer,
  notificationsReducer,
  userReducer,
  i18nReducer,
  chartsReducer,
  accountsReducer,
  alertsReducer,
  tableReducer,
  populationHealthReducer,
  infoPaneReducer,
  orderReducer,
  navigationReducer,
  activePatientReducer,
  userAccountManagementReducer,
  accountEditingReducer,
  instantAssessmentReducer,
  assessmentPerformanceReducer,
  claimsManagerReducer,
  bhiDashboardReducer,
} from 'redux_store/slices';

const store = configureStore({
  reducer: {
    appSettings: appSettingsReducer,
    infoPane: infoPaneReducer,
    notifications: notificationsReducer,
    user: userReducer,
    i18n: i18nReducer,
    charts: chartsReducer,
    accounts: accountsReducer,
    alerts: alertsReducer,
    table: tableReducer,
    populationHealth: populationHealthReducer,
    order: orderReducer,
    navigation: navigationReducer,
    activePatient: activePatientReducer,
    userAccountManagement: userAccountManagementReducer,
    accountEditing: accountEditingReducer,
    instantAssessment: instantAssessmentReducer,
    assessmentPerformance: assessmentPerformanceReducer,
    claimsManager: claimsManagerReducer,
    bhiDashboard: bhiDashboardReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(signalRMiddleware, navigationMiddleware, debugMiddleware),
});

// Inject store into the shared API client so it can dispatch actions
// (logout on 500/2000, maintenance mode, auth expires) without importing
// @app/store directly — that would create a circular dependency.
attachStore(store);

export default store;
